import Handler from "../Handler";

class SitInFailureHandler extends Handler {
  execute(message) {
    let receivedData = JSON.parse(message);
    this.service.processSitInFailure(receivedData);
  }
}

export default SitInFailureHandler;
